module.exports = __webpack_public_path__ + "static/media/bubble2.60ebdc31.svg";